const getSortByValue = (metric: string): string | undefined => {
  switch (metric) {
    case 'performance_this_week_to_date':
    default:
      return 'count_this_week_to_date';
    case 'performance_last_week_to_date':
      return 'count_last_week_to_date';
    case 'performance_wow_in_progress':
      return 'wow_in_progress';
    case 'count_last_week':
      return 'count_last_week';
    case 'performance_last_last_week':
      return 'count_last_last_week';
    case 'performance_wow_last_completed':
      return 'wow_last_completed';
    case 'performance_rtd':
      return 'rtd';
    case 'custom':
      return undefined;
    case 'displayName':
      return 'displayName';
  }
};

export default getSortByValue;
